module.exports = __webpack_public_path__ + "52deb4631b897d7d8b9cb3f59c648135.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/nose.svg
// module id = MRoU
// module chunks = 0